var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckForServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5780",
    "data-name": "Group 5780",
    transform: "translate(-305.375 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_860",
    "data-name": "Ellipse 860",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(305.375 477)",
    fill: "#ceeefb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560",
    transform: "translate(317.375 489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28804",
    "data-name": "Path 28804",
    d: "M22,11c0,4.971-9,13.5-9,13.5S4,15.971,4,11a9,9,0,1,1,18,0Z",
    fill: "none",
    stroke: "#3e90b1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28805",
    "data-name": "Path 28805",
    d: "M12,11a1,1,0,1,0-1-1A1,1,0,0,0,12,11Z",
    transform: "translate(1 0.972)",
    fill: "none",
    stroke: "#3e90b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckForServiceIcon);
export default __webpack_public_path__ + "static/media/checkForServiceIcon.ba4c764410231fa765948490d537f89c.svg";
export { ForwardRef as ReactComponent };